<template>
  <div class="ti-application-error">
    <div class="ti-application-error__inner">
      <div class="ti-application-error__content">
        <svg
          class="error-icon-svg"
          width="64px"
          height="64px"
          viewBox="0 0 64 64"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="icon_conf_error"
            stroke="none"
            stroke-width="1"
            fill="#821414"
            fill-rule="evenodd"
          >
            <path
              d="M32,0 C49.673112,0 64,14.326888 64,32 C64,49.673112 49.673112,64 32,64 C14.326888,64 0,49.673112 0,32 C0,14.326888 14.326888,0 32,0 Z M32,2 C15.4314575,2 2,15.4314575 2,32 C2,48.5685425 15.4314575,62 32,62 C48.5685425,62 62,48.5685425 62,32 C62,15.4314575 48.5685425,2 32,2 Z M42.3246493,16.188359 L47.7798567,21.772251 L37.976,32.048 L47.6863015,42.276256 L42.2830357,47.8083765 L32.002,38.043 L21.7770635,47.8002787 L16.3025904,42.2879568 L26.023,32.048 L16.2201433,21.772251 L21.6754671,16.188359 L31.999,26.042 L42.3246493,16.188359 Z M42.2753816,19 L31.9991334,28.8062827 L21.7246184,19 L19,21.7888307 L28.7840144,32.0453752 L19.0901273,42.2565445 L21.8147457,45 L31.9991334,35.2827225 L42.230318,45 L44.9098727,42.2565445 L35.2159856,32.0453752 L45,21.7888307 L42.2753816,19 Z"
              id="Shape"
              fill="#ae1a1a"
              fill-rule="nonzero"
            ></path>
          </g>
        </svg>
        <h3>{{ headline }}</h3>
        <p>{{ copy }}</p>
        <p v-if="dealerCopy">
          {{ dealerCopy }}
          <a :href="dealerLink ? dealerLink : '#'">{{
            $t('i18n.applicationError.error.LinkCopy')
          }}</a>
        </p>
        <button
          type="button"
          class="wb-button wb-button--primary wb-button--large"
          @click="doReload()"
        >
          <wb-icon
            class="wb-button__icon"
            aria-hidden="true"
            flip-rtl
            name="reload-xs"
          ></wb-icon>
          {{ $t('i18n.applicationError.button') }}
        </button>
      </div>
    </div>
    <StickyBenefits class="ti__sticky-benefits" />
  </div>
</template>
<script lang="ts" setup>
import StickyBenefits from '../../components/sticky-benefits/sticky-benefits.vue';

interface Props {
  headline: string;
  copy: string;
  dealerCopy?: string;
  dealerLink?: string;
}

const props = defineProps<Props>();

const doReload = (): void => {
  location.reload();
};
</script>

<style lang="scss" src="./application-error.scss"></style>
